export default "__VITE_ASSET__68fcdf11__"